import { useState, ChangeEvent } from 'react'
import { BottomNavigation, BottomNavigationAction, Box, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ChevronRight, ChevronLeft } from '@dhl/icons'

import { Basket } from '~/basket/model/reducers'
import { StepNavigation } from '~/basket/view/withBasket'
import { formattedTotalPrice } from '~/basket/view/util/price'
import { zero } from '~/basket/model/utils/price'

type Props = {
  basket?: Basket
  stepNavigation: StepNavigation
  showTotalPrice: boolean
  isLoadingBasket: boolean
}

export const BottomNavigator = ({ basket, stepNavigation, showTotalPrice, isLoadingBasket }: Props) => {
  const [value] = useState('next')
  const { t } = useTranslation()

  const handleChange = (event: ChangeEvent<{}>, newValue: string) => {
    if (newValue === 'back' && stepNavigation.previousSteps.length > 0) {
      stepNavigation.goToPreviousStep()
    }

    if (newValue === 'next' && !isLoadingBasket) {
      stepNavigation.goToNextStep()
    }
  }

  const priceText = () => {
    const days = basket?.delivery ? basket?.delivery.days : 0

    const price = formattedTotalPrice(showTotalPrice && basket ? basket.totalPrice : basket?.price || zero)

    return (
      <Box component="span" textAlign="center">
        <Grid container direction="column">
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>
            {price}
          </Typography>
          {days > 0 && (
            <Typography variant="body2" noWrap>
              {days > 1 ? t('deliverydays_plural', { count: days }) : t('deliverydays', { count: days })}
            </Typography>
          )}
        </Grid>
      </Box>
    )
  }

  return (
    <BottomNavigation value={value} onChange={handleChange} showLabels>
      <BottomNavigationAction
        label={t('back')}
        key="back"
        value="back"
        icon={<ChevronLeft />}
        sx={(theme) =>
          stepNavigation.previousSteps.length === 0
            ? {
                color: theme.palette.text.primary,
                fill: theme.palette.text.primary,
                minWidth: 60,
              }
            : {
                color: theme.palette.primary.main,
                fill: theme.palette.primary.main,
              }
        }
        disableRipple
      />
      <BottomNavigationAction label={priceText()} disabled />
      <BottomNavigationAction
        label={t('next')}
        key="next"
        id="next"
        value="next"
        icon={<ChevronRight />}
        sx={(theme) => ({
          color: theme.palette.primary.main,
          fill: theme.palette.primary.main,
        })}
        disableRipple
      />
    </BottomNavigation>
  )
}
